/* tslint:disable */

declare var Object: any;
export interface SFAttCorrectionRequestSf6Interface {
  "id"?: number;
}

export class SFAttCorrectionRequestSf6 implements SFAttCorrectionRequestSf6Interface {
  "id": number;
  constructor(data?: SFAttCorrectionRequestSf6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttCorrectionRequestSf6`.
   */
  public static getModelName() {
    return "SFAttCorrectionRequestSf6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttCorrectionRequestSf6 for dynamic purposes.
  **/
  public static factory(data: SFAttCorrectionRequestSf6Interface): SFAttCorrectionRequestSf6{
    return new SFAttCorrectionRequestSf6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttCorrectionRequestSf6',
      plural: 'SFAttCorrectionRequestSf6s',
      path: 'SFAttCorrectionRequestSf6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttCorrectionRequestSf6.ts